import React from "react";

import useValueClick from "./useValueClick";

const RecognizedValue = ({ value }) => {
  const onValueClick = useValueClick();

  return <button type="button" onClick={onValueClick}>{value.name}</button>;
};

const separatorFor = items => index => {
  if (index === 0) {
    return null;
  }
  return index === items.length - 1 ? ", and " : ", ";
};

const RecognizedValueList = ({ values }) => {
  if (values.length === 1) {
    return <RecognizedValue value={values[0]} />;
  }

  if (values.length === 2) {
    return (
      <>
        <RecognizedValue value={values[0]} />
        {" "}
        and
        {" "}
        <RecognizedValue value={values[1]} />
      </>
    );
  }

  const listItems = values.map(value => <RecognizedValue key={value.id} value={value} />);
  const separator = separatorFor(listItems);

  if (values.length < 5) {
    return listItems.reduce((accum, listItem, index) => (
      [...accum, separator(index), listItem]
    ), []);
  }

  return listItems.slice(0, 4)
    .reduce((accum, listItem, index) => [...accum, separator(index), listItem], [])
    .concat(`, and ${values.length - 5} more`);
};

export default RecognizedValueList;
